module.exports = __webpack_public_path__ + "static/bradesco-1-672a1bb0a7c26792712d90378d5b6ecc.jpg";